import { USD } from '../../constants/currency-codes';

export const calculateProductAmount = (items, salesOrderItems) => {
  const itemsWithBundles = items.reduce((acc, item) => {
    const salesOrderItem = salesOrderItems ? salesOrderItems[item.salesOrderItemId] : undefined;
    if (!item.bundleProductId || !item.salesOrderItemId || !salesOrderItem) {
      return [...acc, item];
    }

    if (acc.some((i) => i.salesOrderItemId === item.salesOrderItemId)) {
      return acc;
    }

    return [...acc, salesOrderItem];
  }, []);
  return itemsWithBundles.reduce((acc, item) => acc + (item?.totalPrice?.value || 0), 0);
};

export const cleanAmountSummary = ({ value, code }) => ({
  value: value || 0,
  code: code || USD,
});

export const calculateTotalAmount = (productAmount, shippingAmount, taxAmount, isTaxesIncluded = false) =>
  (productAmount || 0) + (shippingAmount || 0) + (isTaxesIncluded ? 0 : taxAmount || 0);

export const subtractTaxFromTotalAmount = (total, taxAmount) => (total ? total - (taxAmount || 0) : total);

export const buildAmountSummary = (shipping = {}, tax = {}, totalPaid = {}, total = {}, isTaxesIncludedInOrdersTotal = false) => ({
  shippingAmount: cleanAmountSummary(shipping),
  taxAmount: cleanAmountSummary(tax),
  totalPaid: cleanAmountSummary(totalPaid),
  total: cleanAmountSummary({
    value: isTaxesIncludedInOrdersTotal ? subtractTaxFromTotalAmount(total?.value, tax?.value) : total?.value,
    code: total?.code,
  }),
});
